import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  filterBtn: {
    // background: `${theme.palette.KenColors.ClientPrimaryGrey} !important`,
    color: `${theme.palette.KenColors.ClientBlack2} !important`,
    boxShadow: 'none !important',
    fontSize: '16px !important',
    padding: '8px 24px !important',
    borderRadius: '8px !important',
    [theme.breakpoints.down('md')]: {
      padding: '8px 20px !important',
      fontSize: '12px !important',
    },
  },
  flexContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardHolder: {
    marginTop: '20px',
    boxShadow: 'none !important',
  },
  hostEventCard: {
    background: `${theme.palette.KenColors.ClientBlue3} !important`,
    padding: '10px 16px',
    borderRadius: '12px !important',
  },
  registerEventsContainer: {
    height: '41vh !important',
    overflowX: 'hidden',
    overflowY: 'auto',
    boxShadow: 'none !important',
  },
  hostEventHeading: {
    textAlign: 'start',
    fontSize: '14px !important',
    color: theme.palette.KenColors.kenWhite,
    fontWeight: '500 !important',
  },
  jobsCard: {
    background: theme.palette.KenColors.ClientGrey2,
    padding: '18px',
    borderRadius: '12px',
    textAlign: 'start'
  },
  jobsCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
    columnGap: '10px',
    rowGap: '6px',
  },
  jobsContentContainer: {
    display: 'flex',
    justifyContent: 'space-between',

    alignItems: 'end',
    marginTop: '18px',
  },
  jobsContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    margin: '10px 0px',
  },
  jobsActionIcon: {
    height: '20px !important',
    width: 'auto',
    color: theme.palette.KenColors.ClientBlack,
    [theme.breakpoints.down('md')]: {
      height: '18px !important',
    },
  },
  jobsContentIcon: {
    height: '14px !important',
    width: '14px !important',
    color: theme.palette.KenColors.ClientGrey,
  },
  categoryContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    rowGap: '8px',
    columnGap: '4px',
    margin: '10px 0px',
  },
  categoryCells: {
    padding: '4px 10px',
    borderRadius: '20px',
    whiteSpace: 'nowrap',
    fontWeight: '400 !important',
    fontSize: '10px !important',
    color: theme.palette.KenColors.ClientBlue5,
  },
  hostAnEventBanner: {
    height: '120px',
    width: 'auto',
    margin: '20px 0px',
  },
  AppliedCard: {
    borderBottom: '0.5px solid rgba(178, 179, 183, 0.5)',
    padding: '18px 26px !important',
    borderRadius: '0px !important',
    cursor: 'pointer',
  },
  companyLogo: {
    objectFit: 'contain',
    background: theme.palette.KenColors.kenWhite,
    borderRadius: '8px',
    padding: '10px',
  },
  inputStyles: {
    height: '48px !important',
    borderRadius: '8px !important',
    borderColor: 'none !important',
    '& fieldset': {
      border: 'none !important',
    },
    [theme.breakpoints.down('md')]: {
      height: '32px !important',
    },
  },
  jobDetailsHead: {
    fontSize: '15px !important',
    fontWeight: '500 !important',
    marginBottom: '20px !important',
  },
  jobContentHead: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    margin: '14px 0px !important',
  },
  jobContent: {
    fontSize: '12px !important',
    fontWeight: '400 !important',
    margin: '14px 0px !important',
    textTransform: 'capitalize',
  },
  similarJobContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    height: '46vh',
    padding: '0px 14px',
    overflowY: 'auto',
  },
  aboutJobContainer: {
    textAlign: 'start',
    padding: '20px',
    height: '54vh !important',
    overflowY: 'scroll',
    '@media (min-width: 1240px) and (max-width: 1280px)': {
      padding: '10px',
      height: '100% !important',
    },
    '@media (min-width: 1430px) and (max-width: 1440px)': {
      height: '56vh !important',
    },
    '@media (min-width: 1540px) and (max-width: 1710px)': {
      height: '52vh !important',
    },
    '@media (min-width: 1710px) and (max-width: 1920px)': {
      height: '60.5vh !important',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      height: '62.3vh !important',
    },
  },
  divider: {
    margin: '14px 0px !important',
    color: theme.palette.KenColors.ClientDivider,
  },
  cellsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '20px !important',
    rowGap: '8px !important',
    overflowX: 'auto',
  },
  jobDetailsActionContainer: {
    padding: '16px !important',
    background: theme.palette.KenColors.kenWhite,
    borderRadius: '8px !important',
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',

    [theme.breakpoints.down('sm')]: {
      padding: '8px !important',
    },
  },

  jobsCardsContainer: {
    width: '100%',
    boxShadow: 'none !important',

    paddingLeft: '20px',
    borderRadius: '16px !important',
    height: 'auto',
    [theme.breakpoints.up('xxl')]: {
      height: 'auto',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: 'auto',
    },
    '@media (min-width: 280px) and (max-width: 600px)': {
      height: 'auto',
    },
  },
  jobsContainer: {
    overflow: 'hidden',
    // height: '94.5vh',
    marginBottom: '10px !important',
    boxShadow: 'none !important',
    borderRadius: '9px !important',
    paddingBottom: '20px !important',
    [theme.breakpoints.down('sm')]: {
      // height: '73.5vh',
    },
    [theme.breakpoints.up('xxl')]: {
      // height: '83.5vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      // height: '81vh !important',
    },
  },
  jobsSuggestionSeleceted: {
    background: `${theme.palette.KenColors.ClientBlue4} !important`,
    color: `${theme.palette.KenColors.ClientBlue5} !important`,
  },
  jobsSelectionUnSelected: {
    background: `${theme.palette.KenColors.ClientGrey3} !important`,
    color: `${theme.palette.KenColors.ClientBlack2} !important`,
  },
  jobRegisterKey: {
    textAlign: 'start',
    fontSize: '16px !important',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.ClientBlack1,
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px !important',
    },
  },
  suggestionCells: {
    fontSize: '16px',
    fontWeight: '500 !important',
    padding: '6px 12px',
    borderRadius: '100px',
    [theme.breakpoints.down('md')]: {
      fontSize: '10px',
      padding: 'auto',
    },
  },
postJobBtns: {
    width: '100%',
    borderRadius: 6,
    padding: 9,
    fontSize: 12,
    fontWeight: 500,
    color: '#5B4200',
    textTransform: 'none',
    transition: 'background-color 0.3s ease, color 0.3s ease',

    '&:hover': {
      backgroundColor: '#2C60AA', // <-- hover background
      color: '#fff',              // <-- hover text color
    },

    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: 10,
      padding: 5,
    },
  },
  similarJobCardContainer: {
    padding: '20px 0px',
    textAlign: 'start',
    height: '56.5vh !important',
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      height: '59vh !important',
    },
  },
  jobsHostBtns: {
    width: '110px !important',
    padding: '12px !important',
    borderRadius: '8px !important',
    fontSize: '16px !important',
    fontWeight: '600 !important',
    height: '36px',
    // color: "#5B4200"
  },
  postJobBtns1: {
    width: '100%',
    borderRadius: '8px !important',
    padding: '10px !important',
    fontSize: '16px !important',
    fontWeight: '500 !important',
    color: "#5B4200 !important",
    [theme.breakpoints.down('md')]: {
      fontSize: '12px !important',
      padding: '10px !important',
      width: '110px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
      padding: '8px !important',
      width: '100px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
      padding: '7px !important',
      width: '90px',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '30px !important',
      fontSize: '10px !important',
    },
  },
  StepperTitle: {
    textAlign: 'left',
    fontSize: 18,
    fontWeight: '500 !important',
  },
  eventsCardBox: {
    borderRadius: '9px !important',
    backgroundColor: '#F6F8FB',
    padding: '5px',
  },
  resumelibraryBox: {
    height: '15vh',
    [theme.breakpoints.up('xxl')]: {
      height: '13vh',
    },
  },
  appliedBox: {
    height: '31vh',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
    [theme.breakpoints.up('xxl')]: {
      height: '35vh',
    },
    '@media (min-width: 1920px) and (max-width: 2000px)': {
      height: '52vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '26.5vh !important',
    },
    '@media (min-width: 1536px) and (max-width: 1636px)': {
      height: '33vh !important',
    },
  },
  filterBox: {
    height: '50vh',
    [theme.breakpoints.up('xxl')]: {
      height: '430px',
    },
  },
  myProfileAppliedData: {
    height: '50vh',
    [theme.breakpoints.up('xxl')]: {
      height: '58vh',
    },
  },
}));
